import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./CustomerPaymentSuccess.module.css";
import { customerVerifyPayment } from "../api";
import useAuthGuard from "../hooks/useAuthGuard";
import usePaymentVerification, { PAYMENT_MESSAGES } from "../hooks/usePaymentVerification";

const VERIFY_MESSAGES = {
  verifying: "Verifying...",
  success: "Your payment was successful. Your booking is now confirmed.",
  processing: PAYMENT_MESSAGES.processing,
  failed: PAYMENT_MESSAGES.failed,
};

const PaymentSuccess = () => {
  useAuthGuard();
  const location = useLocation();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying...");
  const [isChecking, setIsChecking] = useState(true);

  const query = new URLSearchParams(location.search);
  const freeBooking = query.get("freeBooking");
  const cartId = query.get("cart_id");
  const needsVerification = freeBooking !== "1" && !!cartId;

  const { status, checkAgain } = usePaymentVerification(
    customerVerifyPayment,
    cartId,
    needsVerification
  );

  useEffect(() => {
    console.log("Success Page - freeBooking:", freeBooking, "cartId:", cartId);

    if (freeBooking === "1") {
      setMessage("Your booking has been completed successfully.");
      setIsChecking(false);
      return;
    }

    if (!cartId) {
      console.error("No cartId in query string");
      const t = setTimeout(() => {
        setMessage("Missing payment information. Please try again.");
        setIsChecking(false);
      }, 5000);
      return () => clearTimeout(t);
    }
  }, [freeBooking, cartId]);

  const shownMessage = needsVerification ? VERIFY_MESSAGES[status] : message;
  const showButtons = needsVerification ? status !== "verifying" : !isChecking;

  return (
    <div className={styles.container}>
      <h2>{shownMessage}</h2>
      {showButtons && (
        <div>
          {status === "processing" && (
            <button onClick={checkAgain} style={{ marginRight: 12 }}>
              Check again
            </button>
          )}
          <button onClick={() => navigate("/customer/dashboard/booking-list")}>
            Back to Home
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentSuccess;
